<template>
  <div class="wrapper" :class="{ middle }">
    <div class="loader" :style="baseStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  computed: {
    baseStyle() {
      return {
        width: this.size,
        height: this.size,
        borderWidth: this.width,
        borderLeftColor: this.color,
        borderRightColor: this.color,
      };
    },
  },
  props: {
    size: {
      type: String,
      default() {
        return '3rem';
      },
    },
    width: {
      type: String,
      default() {
        return '0.3rem';
      },
    },
    color: {
      type: String,
    },
    middle: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors';

.wrapper {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.middle {
  height: 100%;
  width: 100%;
}

.loader {
  display: inline-block;
  border: 1px solid $darkBlue;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;

  border-radius: 50%;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
